import {executeLogoutFetch, setLogoutActive} from "../../../slices/loginFormSlice";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {DecisionDialog} from "../cms/dialog-windows/DecisionDialog";
import {LogoutIcon} from "../../icons/LogoutIcon";
import {USER_PROFILE} from "../../../utils/viewsConstants";
import {ReactSVG} from "react-svg";
import {setChosenLanguage, setNavPanelCollapsed} from "../../../slices/globalParamsSlice";
import {AppModeSwitcherCollapsed} from "../common/navigation/AppModeSwitcherCollapsed";
import {AppModeSwitcherWrapper} from "../common/navigation/AppModeSwitcherWrapper";
import {Tooltip} from "../cms/Tooltip";
import {languageStylesMobile} from "../../../selectStyles";
import {CustomNoOptionsMessage} from "../cms/form-components/CustomNoOptionsMessage";
import Select from "react-select";
import {CustomSingleValueIcon} from "../cms/form-components/CustomSingleValueIcon";
import {CustomCollapsedOption} from "../cms/form-components/CustomCollapsedOption";
import {useNavPanelDeps} from "../../../hooks/useNavPanelDeps";

export const NavPanelCollapsed = ({childrenCollapsed, clearStateHandler}) => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const {userData} = useSelector(state => state.userProfile.getUserProfile);
    const {
        logoutActive,
        navPanelCollapsed,
        chosenLanguage,
        isLogoutHovered,
        setIsLogoutHovered,
        hasAccessToDashboard,
        handleSwitchView,
        languages
    } = useNavPanelDeps({clearStateHandler});

    const handleLanguageChange = selected => {
        const lang = selected.value;
        dispatch(setChosenLanguage({
            value: lang,
            label: t(lang),
            collapsedLabel: t(`${lang}Short`)
        }));
        i18n.changeLanguage(lang);
    }

    return (
        <div className={`app-nav-panel collapsed`}>
            {logoutActive &&
                <DecisionDialog
                    msg={t('confirmLogout')}
                    onCancel={() => dispatch(setLogoutActive(false))}
                    onSubmit={() => dispatch(executeLogoutFetch({isInactive: false}))}
                />
            }
            <div className={'flex-centered'}>
                <Tooltip content={t('userProfile')} topOffset={20}>
                    <div className={'user-profile-logo'} onClick={() => handleSwitchView(USER_PROFILE)}>
                        {userData?.forename?.[0].toUpperCase()}
                    </div>
                </Tooltip>
            </div>

            <AppModeSwitcherWrapper isCollapsed={true} hasAccessToDashboard={hasAccessToDashboard}>
                <AppModeSwitcherCollapsed/>
            </AppModeSwitcherWrapper>

            <div className={'app-nav-menu collapsed'}>
                <ul className={'app-nav-ul collapsed'}>
                    {childrenCollapsed}
                </ul>
            </div>

            <div className={'collapse-panel-button'}
                 onClick={() => dispatch(setNavPanelCollapsed(!navPanelCollapsed))}>
                <ReactSVG src={`${process.env.PUBLIC_URL}/theme/icons/chevron-right.svg`}/>
            </div>

            <div className={'app-nav-language-wrapper-collapsed'}>
                <Tooltip content={t('language')} topOffset={-20}>
                    <Select id={'language'}
                            name={'language'}
                            styles={languageStylesMobile}
                            value={chosenLanguage}
                            onChange={(selected) => handleLanguageChange(selected)}
                            placeholder={t('chooseLanguage')}
                            isClearable={false}
                            options={languages}
                            isCollapsed={true}
                            components={{
                                NoOptionsMessage: CustomNoOptionsMessage,
                                SingleValue: CustomSingleValueIcon,
                                Option: CustomCollapsedOption
                            }}
                            closeMenuOnSelect={true}
                            menuPlacement={'top'}
                            isSearchable={false}
                            blurInputOnSelect={false}
                    />
                </Tooltip>
            </div>

            <div className={'app-nav-logout-collapsed-container'}
                 onClick={() => dispatch(setLogoutActive(true))}
                 onMouseOver={() => setIsLogoutHovered(true)}
                 onMouseLeave={() => setIsLogoutHovered(false)}>
                <Tooltip content={t('logout')} topOffset={-20}>
                    <LogoutIcon active={isLogoutHovered}
                                collapsed={true}/>
                </Tooltip>
            </div>
        </div>
    );
}